<template>
    <div v-loading="formLoading">
        <el-form :model="form" label-position="top" ref="addWord" :rules="rules">
            <el-form-item label="所属菜单">                        
                {{paramsInfo.parentTitle ? `${paramsInfo.parentTitle}/${paramsInfo.title}`: paramsInfo.title }}                        
            </el-form-item>
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item label="状态" prop="status">
                        <el-select v-model="form.status" placeholder="请选择" style="width: 100%;" size="medium">
                            <el-option label="展示" :value="1"></el-option>
                            <el-option label="隐藏" :value="-1"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item label="名称" prop="title">
                        <el-input v-model="form.title" autocomplete="off" maxlength="40" placeholder="请输入词条名称" size="medium"></el-input>
                    </el-form-item> 
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :xs="24" :xl="16">
                    <el-form-item label="内容" prop="content">
                        <tinymce v-if="isShow" v-model="form.content" :toolbar="toolbar" :menubar="false"></tinymce>
                    </el-form-item>
                </el-col>
            </el-row>  
            <el-form-item>
                <el-button @click="$router.go(-1)">返回取消</el-button>
                <el-button
                    type="primary"
                    @click="submitForm"
                    :loading="submitLoading"
                    >确认提交</el-button
                >
            </el-form-item>                   
        </el-form>        
    </div>
</template>

<script>
import Tinymce from '@/components/Tinymce'; 

const defaultData = {
    status: 1, // 状态
    title: '', // 词条标题
    content: ''
}
export default {
    components: {
        Tinymce
    },    
    data(){
        const {parentTitle, title, firstMenuId, secondMenuId, wordId} = this.$route.params;
        return {
            toolbar:['formatselect fontsizeselect | forecolor bold strikethrough | alignleft aligncenter alignright alignjustify | image media link | preview fullscreen'],
            form: {...defaultData},
            wordId,
            paramsInfo: {
                parentTitle,
                title,
                firstMenuId,
                secondMenuId
            },
            parentMenuOptions: [],
            showChildNum: null,
            submitLoading: false,
            formLoading: false,
            isShow: true,
            rules: {
                pid: [
                    { required: true, message: '请选择父级菜单', trigger: 'change' }
                ],
                title:  [
                    { required: true, message: '请输入词条名称', trigger: 'blur' }
                ],
                content: [
                    { required: true, message: '请输入词条内容', trigger: 'blur' },
                ]
            }
        }
    },
    created(){
        if(this.wordId){
            this.getDetail();
        }        
    },
    methods: {
        getDetail(){
            this.isShow = false;
            this.formLoading = true;
            this.$request({
                url: '/help/entry/getById',
                method: 'post',
                params: {id: this.wordId}
            }).then(res=>{
                const {state, msg, result} = res.data;
                if (state == 1) {
                    this.form = {...result};
                    this.isShow = true;
                    this.$nextTick(()=>{
                        this.formLoading = false;
                    })                    
                } else {
                    this.$message.error(msg || "请求失败");
                }
            })
        },
        submitForm(){
            this.$refs['addWord'].validate((valid) => {
                if (valid) {
                    this.submitLoading = true;
                    const data = {...this.form};
                    data.firstMenuId = this.paramsInfo.firstMenuId;
                    data.secondMenuId = this.paramsInfo.secondMenuId;
                    const url = this.wordId ? '/help/entry/update' : "/help/entry/create";
                    this.$request({
                        url,
                        method: "POST",
                        data
                    }).then(res=>{
                        const {state, msg} = res.data;
                        if (state == 1) {
                            this.$message.success( this.wordId ? '更新成功' : '创建成功');
                            this.$router.go(-1);
                        } else {
                            this.$message.error(msg || "请求失败");
                        }
                    }).catch(() => {
                        this.$message.error("请求错误");
                    }).finally(()=>{
                        this.submitLoading = false;
                    })
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.terminal{
    ::v-deep .el-form-item__content{
        line-height: 34px;
    }
}
.has-tips {
    ::v-deep .el-form-item__label{
        width: 100%;
        display: flex;
        align-items: center;

        & > * {
            flex: 0 0 auto;
        }
        .tips{
            flex: 1 1 auto;
            margin-left: 10px;
            font-size: 12px;
            overflow: hidden;
            max-width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }    
}
</style>